import theme from "../Theme";

export const useTheme = () => {
  return theme;
};
